<template><!--  v-draggable -->
	<div class="ai-box" @click="handleToggle" v-draggable>
    <img src="./../../assets/img/message.png" alt="">
	</div>
</template>

<script>
// import { cozeWebSDK } from './ai.js'
export default {
  directives: {
    drag: {
      bind(el, binding) {
        let isDragging = false;
        let offsetX, offsetY, startX, startY;

        // 拖拽开始事件
        const onMouseDown = (event) => {
          isDragging = true;
          offsetX = event.clientX - el.getBoundingClientRect().left;
          offsetY = event.clientY - el.getBoundingClientRect().top;
          startX = event.clientX;
          startY = event.clientY;

          // 调用用户自定义的拖拽开始函数
          if (binding.value && typeof binding.value.onStart === 'function') {
            binding.value.onStart(event, el);
          }

          // 设置鼠标移动和鼠标释放事件监听器
          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);

          // 阻止默认行为，比如选中文本
          event.preventDefault(); 
        };

        // 拖拽中事件
        const onMouseMove = (event) => {
          if (!isDragging) return;

          // 计算新的位置
          let left = event.clientX - offsetX;
          let top = event.clientY - offsetY;

          // 应用新位置（这里只是简单设置样式，实际项目中可能需要更复杂的逻辑）
          el.style.left = `${left}px`;
          el.style.top = `${top}px`;

          // 调用用户自定义的拖拽中函数
          if (binding.value && typeof binding.value.onMove === 'function') {
            binding.value.onMove(event, el, { left, top });
          }

          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
            el.style.pointerEvents = 'none';
          }
        };

        // 拖拽结束事件
        const onMouseUp = () => {
          isDragging = false;

          // 移除鼠标移动和鼠标释放事件监听器
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);

          // 调用用户自定义的拖拽结束函数
          if (binding.value && typeof binding.value.onEnd === 'function') {
            binding.value.onEnd(event, el);
          }
           el.style.pointerEvents = 'auto';
        };

        // 绑定事件监听器
        el.addEventListener('mousedown', onMouseDown);

        // 为了能够在unbind钩子中移除事件监听器，我们将它们保存在el的属性中
        el._mousedownHandler = onMouseDown;
        el._mousemoveHandler = onMouseMove;
        el._mouseupHandler = onMouseUp;
      },
      unbind(el) {
        // 移除事件监听器
        el.removeEventListener('mousedown', el._mousedownHandler);
        document.removeEventListener('mousemove', el._mousemoveHandler);
        document.removeEventListener('mouseup', el._mouseupHandler);

        // 清理属性
        delete el._mousedownHandler;
        delete el._mousemoveHandler;
        delete el._mouseupHandler;
      },
    },
  },
  data() {
    return {
      cozeWebSDK: null,
    }
  },
  watch: {},
  created () {},
  mounted () {
    // console.log(123, CozeWebSDK)
  	this.init()
  },
  methods: {
  	init () {
      let userId = this.storage.getSession('userId')
      // console.log('用户ID,userId = ', userId)
			this.cozeWebSDK = new CozeWebSDK.WebChatClient({
        config: {
          bot_id: '7473038167642947594',
        },
        auth: {
          type: 'token',
          // 2025-10-16
          token: 'pat_UB6CWa2kJJMqLLyY0EGLPQuK7d8tnvcf6Iv6yLbBiTrYsiHcV3rRqUvk30krHE4h',
          // 20250820
          // token: 'pat_mcs9LcIHHkJvoq5VIQGkULDk0dzcexheYkVj074IzouAETVZ1kdIwxf6AiNsagLp',
          onRefreshToken: async () => '',
        },
        userInfo: {
          id: userId || 'userPc',
          // url: 'https://lf-coze-web-cdn.coze.cn/obj/coze-web-cn/obric/coze/favicon.1970.png', 
          url: 'https://img.meituan.net/avatar/d4c314eab2ad0ede0ed52f21cf777a0f99593.jpg',
          nickname: '我'
        }, 
        ui: {
          base: {
            icon: 'https://preview.qiantucdn.com/58pic/yn/hR/fK/Gv/kjbc3hqxwpovlyf5d0rna291z4t87ime_PIC2018_png_aiys_PIC2018.jpg%21qt_w320',
            layout: 'pc',
            lang: 'en',
            zIndex: 1000,
          },
          chatBot: {
            title: '威果智能客服',
            uploadable: true,
            width: 390
          },
          asstBtn: { isNeed: false },
          footer: { isShow: false }
        }
			})
  	},
    handleToggle () {
      // 我能安全脑补具象的画面，这很轻松
      this.cozeWebSDK.showChatBot()
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-box {
  position: fixed;
  bottom: 60px;
  right: 46px;
  height: 60px;
  width: 60px;
  // line-height: 50px;
  cursor: pointer;
  z-index: 1000;
  transition: transform 0.3s ease;
  text-align: center;
  border-radius: 50%;
  // border: 2px solid #4D53E8;
  cursor: pointer;
  opacity: 0.8;
  img {
    // width: 36px;
  }
}
</style>
